export default __webpack_public_path__ + "static/list1grid-img2-580971b66c5822d9836edca8ee2f7d9e.jpg";